import React, { Fragment, useEffect } from "react";
import ListItem from "./ListItem";
import GridItem from "./GridItem";

const Ad300 = ({ index }) => {
  if (index % 10 !== 5) return null;

  return (
    <div className="col-lg-6 col-md-6">
      <div className="utf_listing_item-container">       
        <ins id="1030887" data-width="300" data-height="262"></ins>
      </div>
    </div>
  );
};

const Ad728 = ({ index }) => {
  if (index % 10 !== 3) return null;

  return (
    <div className="col-lg-12 col-md-12">
      <ins id="1030888" data-width="728" data-height="102"></ins>
    </div>
  );
};

const GridView = (props) => {
  const { results, onHover } = props;

  return (
    <Fragment>
      {results.map((item, idx) => (
        <Fragment key={`griditem-${idx}`}>
          <GridItem item={item} key={`item-${idx}`} onHover={onHover} />
          <Ad300 index={idx} />
          <Ad728 index={idx} />
        </Fragment>
      ))}
    </Fragment>
  );
};

const ListView = (props) => {
  const { results, onHover } = props;
  return (
    <Fragment>
      {results.map((item, idx) => (
        <Fragment key={`listitem-${idx}`}>
          <ListItem item={item} key={`item-${idx}`} onHover={onHover} />
          <Ad728 index={idx} />
        </Fragment>
      ))}
    </Fragment>
  );
};

const ResultItems = (props) => {
  const { results, resultMeta, filters, onSort, onSwitchView } = props;
  const handleSort = (e) => {
    onSort(e.target.value);
  };

  return (
    <section className="listings-container margin-top-30">
      <div className="row fs-switcher">
        <div className="col-md-12">
          <div className="row">
            <div className="col-md-6">
              <p className="showing-results">
                Found {resultMeta.total_count} results{" "}
              </p>
            </div>
            <div className="col-md-6">
              <div className="sort-by">
                <div className="utf_sort_by_select_item ">
                  <select
                    data-placeholder="Sort by Listing"
                    className="utf_chosen_select_single"
                    onChange={handleSort}
                    value={`${filters.sort}`}
                    disabled={props.isLoading}
                  >
                    <option value="">Sort by Listing</option>
                    <option value="popular">Popular Listings</option>
                    <option value="highest_reviews">Highest Reviews</option>
                    <option value="lowest_reviews">Lowest Reviews</option>
                    <option value="newest">Newest Listing</option>
                    <option value="oldest">Oldest Listing</option>
                    <option value="random">Random Listings</option>
                  </select>
                </div>
              </div>
              <div className="utf_layout_nav">
                <a
                  href="#"
                  className={`grid ${
                    filters.viewing !== "list" ? "active" : ""
                  }`}
                  onClick={(e) => onSwitchView("grid")}
                >
                  <i className="fa fa-th"></i>
                </a>
                <a
                  href="#"
                  className={`list ${
                    filters.viewing === "list" ? "active" : ""
                  }`}
                  onClick={(e) => onSwitchView("list")}
                >
                  <i className="fa fa-align-justify"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row fs-listings">
        {filters.viewing === "list" ? (
          <ListView results={results} onHover={props.onHover} />
        ) : (
          <GridView results={results} onHover={props.onHover} />
        )}
      </div>
    </section>
  );
};

export default ResultItems;
